(function () {
  'use strict';

  var BREAKPOINT = '(max-width: 768px)';
  var CATEGORY_PATHS = [
    '/collections/710_100_215_tools_1_7_1',
    '/collections/118_100_202_building_1_16_1',
    '/collections/157_100_203_electrical_1_23_1',
    '/collections/649_100_213_plumbing_1_6_1',
    '/collections/568_100_211_paint_1_15_1',
    '/collections/467_100_209_lawn-and-garden_1_18_1'
  ];

  function findOutsideDock(selector, dock) {
    var nodes = document.querySelectorAll(selector);
    var index;

    for (index = 0; index < nodes.length; index += 1) {
      if (!dock.contains(nodes[index])) {
        return nodes[index];
      }
    }

    return null;
  }

  function searchLocation() {
    return window.matchMedia(BREAKPOINT).matches ? 'mobile' : 'desktop';
  }

  function emitEvent(name, details) {
    var payload = details || {};
    var dataLayerPayload;
    var key;

    try {
      document.dispatchEvent(new CustomEvent(name, { detail: payload }));
    } catch (error) {
      /* CustomEvent is an enhancement only. */
    }

    if (!Array.isArray(window.dataLayer)) {
      return;
    }

    dataLayerPayload = { event: name.replace(':', '_') };
    for (key in payload) {
      if (Object.prototype.hasOwnProperty.call(payload, key)) {
        dataLayerPayload[key] = payload[key];
      }
    }
    window.dataLayer.push(dataLayerPayload);
  }

  function enhanceAutocomplete(form, input, suffix) {
    var list = form.querySelector('.search_autocomplete_wrapper');
    var observer;

    if (!list) {
      if (form.getAttribute('data-kjs-autocomplete-waiting') === 'true' || !('MutationObserver' in window)) {
        return;
      }

      form.setAttribute('data-kjs-autocomplete-waiting', 'true');
      observer = new MutationObserver(function () {
        if (form.querySelector('.search_autocomplete_wrapper')) {
          observer.disconnect();
          form.removeAttribute('data-kjs-autocomplete-waiting');
          enhanceAutocomplete(form, input, suffix);
        }
      });
      observer.observe(form, { childList: true });
      return;
    }

    if (list.getAttribute('data-kjs-autocomplete-enhanced') === 'true') {
      return;
    }

    list.id = 'KjsRelease2Suggestions' + suffix;
    list.setAttribute('role', 'listbox');
    list.setAttribute('aria-label', 'Product suggestions');
    list.setAttribute('data-kjs-autocomplete-enhanced', 'true');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-controls', list.id);
    input.setAttribute('aria-expanded', 'false');

    function links() {
      return Array.prototype.slice.call(list.querySelectorAll('a[href]'));
    }

    function visible() {
      var rect = list.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0 && window.getComputedStyle(list).display !== 'none';
    }

    function sync() {
      var items = links();
      var index;

      input.setAttribute('aria-expanded', visible() && items.length ? 'true' : 'false');
      for (index = 0; index < items.length; index += 1) {
        items[index].setAttribute('role', 'option');
        items[index].id = list.id + 'Option' + index;
      }
    }

    function close() {
      list.style.display = 'none';
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
    }

    input.addEventListener('keydown', function (event) {
      var items = links();

      if ((event.key === 'ArrowDown' || event.key === 'ArrowUp') && visible() && items.length) {
        event.preventDefault();
        items[event.key === 'ArrowDown' ? 0 : items.length - 1].focus();
      } else if (event.key === 'Escape') {
        close();
      }
    });

    list.addEventListener('keydown', function (event) {
      var items = links();
      var current = items.indexOf(event.target);
      var next;

      if (current === -1) {
        return;
      }

      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        next = event.key === 'ArrowDown' ? (current + 1) % items.length : (current - 1 + items.length) % items.length;
        items[next].focus();
      } else if (event.key === 'Escape') {
        event.preventDefault();
        close();
        input.focus();
      }
    });

    if ('MutationObserver' in window) {
      observer = new MutationObserver(sync);
      observer.observe(list, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class'] });
    }
    sync();
  }

  function prepareForm(form, suffix) {
    var input = form.querySelector('input[name="q"]');
    var label;

    if (!input) {
      return;
    }

    input.id = 'KjsRelease2Search' + suffix;
    input.setAttribute('enterkeyhint', 'search');
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('autocapitalize', 'off');
    input.setAttribute('spellcheck', 'false');
    input.setAttribute('aria-label', 'Search products, brands or item codes');
    input.setAttribute('placeholder', 'Search products, brands or item codes');

    if (!form.querySelector('label[for="' + input.id + '"]')) {
      label = document.createElement('label');
      label.className = 'kjs-visually-hidden';
      label.setAttribute('for', input.id);
      label.textContent = 'Search products, brands or item codes';
      form.insertBefore(label, form.firstChild);
    }

    form.setAttribute('role', 'search');
    form.setAttribute('data-kjs-search-form', suffix.toLowerCase());
    enhanceAutocomplete(form, input, suffix);
  }

  function bindDockEvents(dock) {
    if (dock.getAttribute('data-kjs-events-bound') === 'true') {
      return;
    }
    dock.setAttribute('data-kjs-events-bound', 'true');

    dock.addEventListener('focusin', function (event) {
      var input = event.target;
      if (input && input.name === 'q' && input.getAttribute('data-kjs-focus-sent') !== 'true') {
        input.setAttribute('data-kjs-focus-sent', 'true');
        emitEvent('kjs:search_focus', { search_location: searchLocation() });
      }
    });

    dock.addEventListener('submit', function (event) {
      var form = event.target;
      var input;
      var length;

      if (!form || !form.querySelector('input[name="q"]')) {
        return;
      }

      input = form.querySelector('input[name="q"]');
      length = input.value.replace(/^\s+|\s+$/g, '').length;
      emitEvent('kjs:search_submit', {
        search_location: searchLocation(),
        search_term_length: Math.min(length, 100)
      });
    }, true);
  }

  function bindStickyState(dock) {
    var sentinel = document.querySelector('[data-kjs-search-sentinel]');
    var originalParent;
    var fixed = false;

    if (!sentinel || dock.getAttribute('data-kjs-sticky-bound') === 'true') {
      return;
    }
    dock.setAttribute('data-kjs-sticky-bound', 'true');

    originalParent = sentinel.parentNode;

    function setStuck(stuck) {
      var height;

      if (stuck === fixed) {
        return;
      }

      fixed = stuck;
      if (stuck) {
        height = dock.offsetHeight;
        sentinel.style.height = height + 'px';
        sentinel.classList.add('is-stuck');
        document.body.appendChild(dock);
        dock.classList.add('is-stuck');
      } else {
        originalParent.insertBefore(dock, sentinel.nextSibling);
        dock.classList.remove('is-stuck');
        sentinel.classList.remove('is-stuck');
        sentinel.removeAttribute('style');
      }
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var entry = entries[0];
        setStuck(!entry.isIntersecting && entry.boundingClientRect.top < 0);
      }, { threshold: 0 }).observe(sentinel);
    } else {
      window.addEventListener('scroll', function () {
        setStuck(sentinel.getBoundingClientRect().top < 0);
      }, { passive: true });
    }
  }

  function hideEmptyCollectionFilter() {
    var sidebar = document.querySelector('.template-collection .sidebar_filter');
    var content;

    if (!sidebar) {
      return;
    }

    content = sidebar.querySelector('.tgl_c');
    if (content && !content.querySelector('a, input, select, button')) {
      sidebar.setAttribute('hidden', 'hidden');
      document.body.classList.add('kjs-r2-no-collection-filters');
    }
  }

  function bindStorefrontMeasurement() {
    if (document.body.getAttribute('data-kjs-r2-measurement-bound') === 'true') {
      return;
    }
    document.body.setAttribute('data-kjs-r2-measurement-bound', 'true');

    if (document.body.classList.contains('template-product')) {
      emitEvent('kjs:product_view', { path: window.location.pathname });
    }

    document.addEventListener('submit', function (event) {
      var action = event.target && event.target.getAttribute('action');
      if (action && action.indexOf('/cart/add') !== -1) {
        emitEvent('kjs:add_to_cart', { path: window.location.pathname });
      }
    }, true);

    document.addEventListener('click', function (event) {
      var node = event.target;
      var href;
      while (node && node !== document.body && node.tagName !== 'A') {
        node = node.parentNode;
      }
      if (!node || node.tagName !== 'A') {
        return;
      }

      href = node.getAttribute('href') || '';
      if (CATEGORY_PATHS.indexOf(href.split('?')[0]) !== -1) {
        emitEvent('kjs:category_click', { destination: href.split('?')[0] });
      } else if (document.body.classList.contains('template-search') && href.indexOf('/products/') !== -1) {
        emitEvent('kjs:search_result_click', { destination: href.split('?')[0] });
      } else if (href.indexOf('/checkout') !== -1) {
        emitEvent('kjs:checkout_click', { source_path: window.location.pathname });
      }
    }, true);
  }

  function initializeSearchDock() {
    var dock = document.querySelector('[data-kjs-search-dock]');
    var desktopSlot;
    var mobileSlot;
    var desktopSearch;
    var mobileSearch;
    var desktopForm;
    var mobileForm;

    if (!dock || dock.getAttribute('data-kjs-initialized') === 'true') {
      return;
    }

    desktopSlot = dock.querySelector('[data-kjs-search-slot="desktop"]');
    mobileSlot = dock.querySelector('[data-kjs-search-slot="mobile"]');
    desktopSearch = findOutsideDock('#header #nav .hidden-xs.navbar-right .fixed-search', dock) ||
      findOutsideDock('#header #nav li .fixed-search:not(.navbar-cart)', dock);
    mobileSearch = findOutsideDock('#header .visible-mobile-xs.mobile-portrait-search', dock);

    if (!desktopSlot || !mobileSlot || !desktopSearch || !mobileSearch || desktopSearch === mobileSearch) {
      return;
    }

    desktopForm = desktopSearch.querySelector('form');
    mobileForm = mobileSearch.querySelector('form');
    if (!desktopForm || !mobileForm) {
      return;
    }

    desktopSlot.appendChild(desktopSearch);
    mobileSlot.appendChild(mobileSearch);
    prepareForm(desktopForm, 'Desktop');
    prepareForm(mobileForm, 'Mobile');
    bindDockEvents(dock);
    bindStickyState(dock);
    dock.setAttribute('data-kjs-initialized', 'true');
    dock.hidden = false;
  }

  function initializeRelease2() {
    initializeSearchDock();
    hideEmptyCollectionFilter();
    bindStorefrontMeasurement();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeRelease2);
  } else {
    initializeRelease2();
  }

  document.addEventListener('shopify:section:load', initializeRelease2);
}());

